{
  "account_disconnected": "Аккаунт успешно отвязан",
  "active_switch": "Включить синхронизацию",
  "active_switch_description": "Включите для начала синхронизации со провайдером",
  "add_another_account": "Добавить еще аккаунт",
  "available_integrations": "Доступные интеграции",
  "connect": "Подключить",
  "connected_integrations": "Подключенные интеграции",
  "demo_email_delivery_description": "В демо-окружении письма не доставляются адресатам, а перенаправляются во внутренний ящик Mailpit.",
  "demo_email_delivery_title": "Доставка писем перенаправляется на демо",
  "demo_http_workflow_description": "В демо-окружении исходящие HTTP-запросы отключены. Запуск воркфлоу с этим блоком завершится ошибкой.",
  "demo_http_workflow_title": "HTTP-блоки воркфлоу недоступны на демо",
  "demo_slack_notifications_description": "В демо-окружении каналы уведомлений Slack недоступны. Их можно настроить, но уведомления не будут доставлены.",
  "demo_slack_notifications_title": "Уведомления Slack недоступны на демо",
  "demo_unavailable_description": "Внешние интеграции нельзя подключить в демо-окружении.",
  "demo_unavailable_tag": "Недоступно на демо",
  "demo_webhooks_description": "В демо-окружении исходящие вебхуки отключены. Их можно настроить, но запросы не будут отправлены.",
  "demo_webhooks_title": "Доставка вебхуков недоступна на демо",
  "disconnect": "Отключить",
  "disconnect_confirm": "Отключить интеграцию?",
  "employee_link_status_linked": "Привязан",
  "employee_link_status_not_found": "Не найден",
  "employees_not_found_count": "Не найдено: {count}",
  "from_slack": "Из Slack",
  "gmail_account": "Аккаунт Gmail",
  "google_calendar_active_switch": "Включить синхронизацию с Google Календарем",
  "google_calendar_active_switch_description": "Включите, чтобы начать автоматическую синхронизацию событий %APP_NAME% с Google Календарем",
  "google_calendar_credentials": "Вставьте учетные данные API Google",
  "google_calendar_credentials_description": "Введите учетные данные JSON из вашей учетной записи сервиса Google Cloud, чтобы включить интеграцию с Google Календарем",
  "google_calendar_description": "Интеграция синхронизирует события между %APP_NAME% и Google Календарем",
  "google_calendar_email": "Почта календаря",
  "google_calendar_employees_not_found_description": "Эти сотрудники не привязаны к Google Календарю: их не нашли по рабочей почте. Проверьте почту и запустите синхронизацию",
  "google_calendar_identity": "Электронная почта супер администратора",
  "google_calendar_install_description": "Google Календарь — это важный инструмент для повышения продуктивности, и с этой интеграцией %APP_NAME% вы больше не пропустите ни одной важной встречи один на один или интервью. После установки все запланированные интервью или встречи в %APP_NAME% будут автоматически синхронизированы с вашим Google Календарем.\n\nЭта интеграция также добавляет ссылку Google Meet к каждому запланированному событию, что упростит вам присоединение к виртуальным встречам без необходимости вручную создавать ссылки.\n\nЭто интеграция для всей компании, которая автоматически подключает календари всех сотрудников, чьи электронные адреса совпадают между вашим Workspace и %APP_NAME%.",
  "google_calendar_install_help": "Для подробного пошагового руководства",
  "google_calendar_install_help_link": "нажмите здесь",
  "google_calendar_install_overview": "Обзор",
  "google_calendar_sync_out_of_office_events_description": "Автоматически блокировать календарь и отклонять встречи при одобрении заявок на отсутствие. Создает события \"Вне офиса\", которые предотвращают новые приглашения на встречи и уведомляют коллег об отсутствии.",
  "google_calendar_sync_out_of_office_events_title": "Синхронизация отсутствий с Google Календарем",
  "google_calendar_title": "Google Календарь",
  "google_workspace_description": "Автоматизируйте создание корпоративных Gmail и Google аккаунтов при найме, приостанавливайте доступ при увольнении",
  "google_workspace_not_connected": "Google Workspace не подключен",
  "google_workspace_not_connected_description": "Подключите Google Workspace для включения синхронизации",
  "google_workspace_title": "Google Workspace",
  "is_active": "Активно",
  "last_synced": "Последняя синхронизация",
  "manage": "Настроить",
  "mcp_copy_address": "Скопировать адрес",
  "mcp_description": "Работайте с данными %APP_NAME% из Claude, ChatGPT, Cursor или VS Code. Добавьте этот адрес сервера в AI-клиент.",
  "mcp_how_to_connect": "Как подключить",
  "mcp_organization_description": "Каждый сотрудник подключает Claude, ChatGPT, Cursor или VS Code к своей учётной записи.",
  "mcp_title": "Claude и другие AI-клиенты",
  "not_active": "Неактивно",
  "not_connected": "Не подключено",
  "outlook_account": "Аккаунт Outlook",
  "reconnect": "Переподключить",
  "settings_integrations_description": "Объедините ваши HR-инструменты",
  "settings_integrations_title": "Интеграции",
  "slack_account_disconnect_confirm": "Отключить интеграцию со Slack?",
  "slack_account_disconnect_confirm_description": "Вы перестанете получать уведомления в Slack, синхронизация данных прекратится",
  "slack_active_switch": "Включить синхронизацию со Slack",
  "slack_active_switch_description": "Включите для начала синхронизации со Slack",
  "slack_description": "Получайте мгновенные обновления о доступности команды и управляйте заявками на отсутствие прямо в Slack",
  "slack_email": "Почта в Slack",
  "slack_employees_not_found_description": "Эти сотрудники не привязаны к Slack: их не нашли по рабочей почте. Проверьте почту и запустите синхронизацию",
  "slack_name": "Имя в Slack",
  "slack_not_connected": "Slack не подключен",
  "slack_not_connected_description": "Подключите рабочее пространство Slack для включения синхронизации",
  "slack_reconnection_required_description": "Мы обновили разрешения приложения для улучшения функциональности. Переподключите Slack, чтобы продолжить синхронизацию данных.",
  "slack_reconnection_required_title": "Требуется переподключение Slack",
  "slack_sync_address_description": "Обновлять профиль Slack адресом сотрудника",
  "slack_sync_address_title": "Синхронизация рабочего места",
  "slack_sync_hired_on_description": "Добавлять дату начала работы сотрудника в профиль Slack",
  "slack_sync_hired_on_title": "Синхронизация даты начала работы",
  "slack_sync_name_description": "Обновлять имя из %APP_NAME% в Slack как полное имя",
  "slack_sync_name_title": "Синхронизация отображаемого имени",
  "slack_sync_photo_description": "Обновить фотографию профиля в %APP_NAME% используя фотографию из Slack",
  "slack_sync_photo_title": "Синхронизация фото профиля",
  "slack_sync_position_description": "Поддерживать актуальность должности в Slack с текущей позицией",
  "slack_sync_position_division_description": "Отображать подразделение сотрудника из %APP_NAME% в профиле Slack",
  "slack_sync_position_division_title": "Синхронизация подразделения",
  "slack_sync_position_title": "Синхронизация должности",
  "slack_title": "Slack",
  "sync_now": "Синхронизировать сейчас...",
  "sync_settings": "Настройки синхронизации",
  "sync_started": "Синхронизация запущена. Статусы обновятся после её завершения",
  "to_slack": "В Slack",
  "zoom_connected": "Zoom подключен",
  "zoom_connected_description": "Встречи в Zoom создаются от имени Zoom-пользователя с email организатора",
  "zoom_description": "Добавляйте ссылки Zoom во встречи и интервью",
  "zoom_not_connected": "Zoom не подключен",
  "zoom_not_connected_description": "Подключите Zoom-аккаунт компании, чтобы добавлять ссылки Zoom во встречи. Подключить может только администратор Zoom-аккаунта",
  "zoom_title": "Zoom",
  "~": "~"
}
